import React from "react";
import { motion } from "framer-motion";
import { TID } from "../../lib/testIds";

const ITEMS = [
  { k: "13+", label: "Years of Engineering Experience" },
  { k: "∞", label: "Multi-Disciplinary Product Teams" },
  { k: "AI·SaaS·Cloud", label: "Engineering Expertise" },
  { k: "Global", label: "Delivery Experience" },
];

export const TrustStrip = () => {
  return (
    <section
      data-testid={TID.trustStrip}
      className="relative border-y border-white/10 bg-[#0A0A0A]"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-px w-8 bg-white/30" />
          <p className="font-mono text-[10px] md:text-xs uppercase tracking-[0.25em] text-zinc-500">
            Engineering products for ambitious businesses across global markets
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-white/10">
          {ITEMS.map((it, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="bg-[#0A0A0A] p-6 md:p-8 flex flex-col gap-2"
            >
              <span className="font-headings text-3xl md:text-5xl font-black tracking-tight text-white">
                {it.k}
              </span>
              <span className="font-mono text-[10px] md:text-xs uppercase tracking-[0.15em] text-zinc-500 leading-relaxed">
                {it.label}
              </span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
